<template>
  <div class="care-plan-card-tab-wrapper">
    <div class="care-plan-card-tab-container">
      <div class="tab-list">
        <div class="tab-item-wrapper">
          <div
            class="tab-item"
            :class="{'active': !isAnnualActive}"
            @click="setIsAnnualActive(false)">
            {{ $t('care.tab.month') }}
          </div>
        </div>
        <div class="tab-item-wrapper">
          <div
            class="tab-item"
            :class="{'active': isAnnualActive}"
            @click="setIsAnnualActive(true)">
            {{ $t('care.tab.annual') }}
          </div>
        </div>
      </div>
      <div class="tab-content-container">
        <div class="care-plan-card-list-outer-wrapper" :class="{'card-list': !isMobile}">
          <care-plan-card-slider
            v-if="isMobile"
            :is-annual-active="isAnnualActive"
            :plan-card-list="planCardList">
          </care-plan-card-slider>
          <care-plan-card-list
            v-else
            :is-annual-active="isAnnualActive"
            :plan-card-list="planCardList">
          </care-plan-card-list>
        </div>
        <div class="care-plan-link-btn-wrapper">
          <a :href="btnSubscriptionLink" target="_blank">
            <div class="btn">{{ $t('care.sectionSubscription.btnText') }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

// NOTE: 兼容 origin / pro 方案
import displayConfig from '../../configs/displayConfig';
import planCardListPro from '../../enums/planCardListPro';
import planCardListBackup from '../../enums/planCardListBackup';
import { getCarePriceDiscountStatus } from '../../services/marketing';
import CarePlanCardList from './CarePlanCardList.vue';
import CarePlanCardSlider from '../sliders/CarePlanCardSlider.vue';

export default {
  name: 'care-plan-card-tab',
  components: {
    CarePlanCardList,
    CarePlanCardSlider,
  },
  data() {
    return {
      isAnnualActive: true,
    };
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile',
    }),
    btnSubscriptionLink() {
      let url = 'https://my.lollipop.camera/subscription2?utm_source=official_website&utm_content=page_care_section_plan_btn';
      const searchParams = new URLSearchParams(window.location.search);

      if (searchParams.has('utm_medium') && searchParams.has('utm_campaign')) {
        url = `${url}&utm_medium=${searchParams.get('utm_medium')}&utm_campaign=${searchParams.get('utm_campaign')}`;
      }

      if (searchParams.has('email') && searchParams.has('cameraId') && searchParams.has('planId')) {
        const encodedEmail = encodeURIComponent(searchParams.get('email'));
        url = `${url}&email=${encodedEmail}&cameraId=${searchParams.get('cameraId')}&planId=${searchParams.get('planId')}`;
      }

      return url;
    },
    hasDiscount() {
      return getCarePriceDiscountStatus();
    },
    planCardList() {
      if (displayConfig.isPlanCompatible) {
        return planCardListBackup;
      }

      return planCardListPro;
    },
  },
  methods: {
    setIsAnnualActive(value) {
      this.isAnnualActive = value;
    },
  },
};
</script>
<style lang="sass" scoped>
.care-plan-card-tab-wrapper
  --tab-font-size: 24px
  --tab-icon-width: 44px
  --card-list-max-width: 100vw
  --card-list-mb: 52px
  --btn-text-font-size: 18px
  padding-top: 32px
  .care-plan-card-tab-container
    display: flex
    flex-direction: column
    align-items: center
    .tab-list
      display: flex
      font-size: var(--tab-font-size)
      font-weight: 400
      .tab-item-wrapper
        position: relative
        .icon-img-wrapper
          width: var(--tab-icon-width)
          height: var(--tab-icon-width)
          position: absolute
          top: 0
          right: 0
          transform: translate(50%, -50%)
          display: inline-block
          img
            width: var(--tab-icon-width)
            height: var(--tab-icon-width)
        .tab-item
          display: inline-block
          color: $main-text-content-color-dark
          background-color: $background-primary
          padding: 12px 16px
          box-shadow: 4px -2px 4px rgba(0, 0, 0, 0.1)
          border-radius: 10px 10px 0 0
          cursor: pointer
          &.active
            color: $main-text-content-color-light
            background-color: $lollipop-blue
            box-shadow: none
    .tab-content-container
      width: 100vw
      display: flex
      flex-direction: column
      justify-content: flex-start
      align-items: center
      background-color: #F4F4F4
      padding: 48px 0
      .care-plan-card-list-outer-wrapper
        max-width: var(--card-list-max-width)
        display: flex
        justify-content: flex-start
        margin-bottom: var(--card-list-mb)
        &.card-list
          overflow-x: scroll
      .care-plan-link-btn-wrapper
        font-size: var(--btn-text-font-size)

@media screen and (max-width: 1440px)
  .care-plan-card-tab-wrapper
    --card-list-max-width: 80vw

@media screen and (max-width: 768px)
  .care-plan-card-tab-wrapper
    --card-list-mb: 20px

@media screen and (max-width: 576px)
  .care-plan-card-tab-wrapper
    --tab-font-size: 18px
    --btn-text-font-size: 16px

@media screen and (max-width: 414px)
  .care-plan-card-tab-wrapper
    --tab-font-size: 16px
    --tab-icon-width: 38px
    .care-plan-card-tab-container
      .tab-list
        .tab-item-wrapper
          .icon-img-wrapper
            position: absolute
            top: 0
            right: 0
            transform: translate(-50%, -50%)
            &.mobile-icon
              transform: translate(-223%, -70%)
          .tab-item
            width: 50vw

@media screen and (max-width: 360px)
  .care-plan-card-tab-wrapper
    --tab-font-size: 14px
    --tab-icon-width: 32px

@media screen and (max-width: 320px)
  .care-plan-card-tab-wrapper
    --tab-font-size: 12px

/** iPad Pro */
@media screen and (min-width: 960px) and (min-aspect-ratio: 3/5) and (max-aspect-ratio: 9/10)
  .care-plan-card-tab-wrapper
    --tab-font-size: 24px
    --card-list-mb: 32px
    --btn-text-font-size: 24px

</style>
